import { mapData } from "@/utilities/DataMapping";
import { PagePartComponent, QuestionTextLayout } from "@/model/Enums";
import { IPagePartOptions } from "./IPagePartOptions";

export class CheckboxChoicesOptions implements IPagePartOptions {
    
    constructor(data?: IPagePartOptions) {
        if (data) this.update(data);
    }

    update(data: IPagePartOptions): CheckboxChoicesOptions {
        mapData(data, { root: () => this });
        return this;
    }

    get component(): PagePartComponent {
        return PagePartComponent.CheckboxChoices;
    }
    set component(value: PagePartComponent) {
        if(value != this.component) console.warn(`IPagePartOptions - trying to set component ${this.component} -> ${value}`)
    }

    // ADDING PROPERTIES - you also need to update the toJSON method!
    html: string = "";
    choices: Array<string> = [];
    correctIndeces: Array<number> = [];
    isRedLineQuestion: boolean = false;

    // set in Briefing.vue to show 'error' message for missing answer
    shouldShowMissingMessage: boolean = false;

    layoutType: QuestionTextLayout = QuestionTextLayout.QuestionAbove;

    // getter / setter properties are not serialised by JSON.stringify unless we do this:
    toJSON(): any {
        return {
            component: this.component,
            html: this.html,
            choices: this.choices,
            correctIndeces: this.correctIndeces,
            isRedLineQuestion: this.isRedLineQuestion,
            layoutType: this.layoutType
        };
    }
}